const todoNote = {
  id: null,
  todoId: null,
  notes: null,
  createdBy: null,
  updatedBy: null,
  createdAt: null,
  updatedAt: null
}

export default () => Object.assign({}, todoNote)
